import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie"; // Install 'js-cookie' package if not already installed
import Navbar from "components/Navbars/AuthNavbar";
import Footer from "components/Footers/Footer";
import BlockUiOverlay from "../Expense/BlockUiOverlay";
import BASE_URL from "../BaseUrl/apiConfig"; // Adjust import based on your project structure
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const EmailChecker = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailStatus, setEmailStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [emailApiKey, setEmailApiKey] = useState("");

  const history = useHistory();

  // Function to fetch and set API key
  const fetchApiKey = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/Expense/getApiverifykey`
      );
      const apiKey = response.data.msg;

      // Set API key state
      setEmailApiKey(apiKey);

      // Save API key in cookies
      Cookies.set("VerifyEmailAPIKey", apiKey, { expires: 7 }); // Expires in 7 days
    } catch (error) {
      console.error("Error fetching API key:", error);
      // Handle error, perhaps set a default API key or show a message
    }
  };

  useEffect(() => {
    // Fetch API key when component mounts
    fetchApiKey();
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  const verifyEmail = async () => {
    setLoading(true);
    setEmailStatus(null);
    setErrorMessage("");

    if (!email) {
      setErrorMessage("Email address cannot be empty.");
      setLoading(false);
      return;
    }

    try {
      // Fetch API key from cookies
      const apiKey = Cookies.get("VerifyEmailAPIKey");

      if (!apiKey) {
        throw new Error("API key not found in cookies.");
      }

      const response = await axios.get(
        `https://emailverifier.reoon.com/api/v1/verify?email=${email}&key=${apiKey}&mode=power`
      );

      const data = response.data;
      setEmailStatus(data);
      console.log("Verification Result:", data);
    } catch (error) {
      console.error("Error verifying email:", error);
      setErrorMessage("Error verifying email");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setEmail(e.target.value);
    setEmailStatus(null); // Clear status message
    setErrorMessage(""); // Clear error message
  };

  return (
    <>
      <Navbar />
      <div className="cust-div min-h-content-minvh">
        <BlockUiOverlay visible={loading} />
        <div className="container mx-auto p-4">
          <div className="flex items-center justify-between mb-4">
            <h1 className="text-2xl font-bold">Verify Email</h1>
            <div>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 mr-3 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                onClick={() => history.goBack()}
              >
                <i
                  className="fa fa-arrow-circle-left mr-1"
                  title="Go To All Message logs"
                ></i>
                Go Back
              </button>
            </div>
          </div>
          <div className="flex items-center mb-3">
            <div className="flex w-full">
              <input
                type="email"
                className="form-control custom-height w-full mr-4"
                placeholder="Please enter email address for verify"
                value={email}
                onChange={handleInputChange}
                id="email"
              />
              <button
                className="px-4 py-2 text-white bg-blue-500 rounded-md text-xs md:text-base font-bold uppercase mb-1 shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 custom-button"
                onClick={verifyEmail}
                style={{ width: "400px" }}
              >
                Verify Email
              </button>
            </div>
          </div>
          {errorMessage && (
            <p
              style={{ marginTop: "-17px !imporatant" }}
              className="text-red-500 mt-2"
            >
              {errorMessage}
            </p>
          )}
          {emailStatus && (
            <h3 className="mt-2">
              <span
                style={{
                  color: emailStatus.status === "safe" ? "#38a169" : "#e53e3e",
                }}
              >
                {emailStatus.status === "safe"
                  ? `"${email}" is a valid email address.`
                  : `"${email}" is an invalid email address.`}
              </span>
            </h3>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default EmailChecker;
